// extracted by mini-css-extract-plugin
module.exports = {"input":"TileOption-input-1pFNQ","label":"TileOption-label-2YaIM typography-bodyCopy-3JspD","checked":"TileOption-checked-Ywl6F"};